
import axios from "../services/axios-config.js";


// FUNÇÃO DE BUSCA DOS DADOS DAS COMPANHIAS
export const getCompanies = async () => {
    return new Promise(async (resolve, reject) => {
        try {
    
            const res = await axios.get(`/admin/companies`);
    
            if (res.status == 200) {
                const array = res.data.sort((a, b) => {
                    const dateA = new Date(a.createdAt);
    
                    const dateB = new Date(b.createdAt);
    
                    return dateA - dateB;
                })

                return resolve(array);

            }
    
        } catch (error) {
            console.error("ERROR - GET COMPANIES FUNCTION:", error);
            reject(error);
    
        }

    })

};